import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {IReferral} from "../../../../@core/interfaces/user/user.interface";
import {UserService} from "../../../../@shared/services/user.service";
import {FormControl, Validators} from "@angular/forms";
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'app-referral-info',
  templateUrl: './referral-info.component.html',
  styleUrls: ['./referral-info.component.scss']
})
export class ReferralInfoComponent {
  public isGoFast: boolean = environment.projectName === 'CSGOFAST';
  public referralDetails: IReferral;
  public refCode: FormControl<any> = new FormControl<string>('', [Validators.required])

  public typeDictionary: Record<string, string> = {
    'gofast': 'стандартный на деньги при пополнении',
    'gofast-custom-money': 'кастомный на деньги при пополнении',
    'gofast-custom-percent': 'кастомный на процент при пополнении'
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public referral: IReferral,
    public dialogRef: MatDialogRef<ReferralInfoComponent>,
    public userService: UserService
  ) {
    this.referralDetails = this.referral;
  }

  /**
   * 9 июня 2026 — дата миграции реферальной системы на новую (перенос фактов выдачи
   * наград в `users_referral_rewards`) и массового заполнения базы. Для всех наград,
   * проставленных этой датой бэкфилла, `createdAt` не отражает реальный момент получения,
   * поэтому в модалке дату получения для неё скрываем.
   */
  public isHiddenRewardDate(createdAt?: string): boolean {
    if (!createdAt) {
      return false;
    }
    const date = new Date(createdAt);
    return date.getFullYear() === 2026 && date.getMonth() === 5 && date.getDate() === 9;
  }

  public changeUserRefCode() {
    this.userService.changeUserRefCode(this.refCode.value).subscribe((referral: IReferral) => {
      this.referralDetails = referral;
      this.refCode.reset();
    })
  }

  close() {
    this.dialogRef.close();
  }
}
